import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';

import Content from '../../component/ContentWrapper/Content/Content';
import Error from '../../component/ContentWrapper/Content/Error/Error';
import { authAction } from '../../component/Login/LoginForm';
import LoginPage from '../../component/Page/LoginPage';
import ProtectedRoute from '../../component/Route/ProtectedRoute';

import ContentPage from '../../component/Page/ContentPage';

import { loadDeviceDetails } from './loader/load-device-details';
import { rootLoader } from './loader/root-loader';
import { authAndLoadDevicesOnHealthMonitor } from './loader/auth-and-load-devices-on-health-monitor';

import { loginLoader } from '../auth';
import StatisticPage from '../../component/Page/StatisticPage';
import { t } from 'i18next';

import money from "../../assets/img/svg/title/money.svg";
import pulse from "../../assets/img/jpg/health-monitor/health-monitor-title-pulse.png"
import { FilterType } from '../../enum/FilterType';
import CashRegisterPage from '../../component/Page/CashRegister/CashRegisterPage';

const HealthMonitor = lazy(() => import('../../component/ContentWrapper/Content/HealthMonitor/HealthMonitor'));
const DeviceDetails = lazy(
  () => import('../../component/ContentWrapper/Content/HealthMonitor/DeviceDetails/DeviceDetails'),
);

export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <ContentPage></ContentPage>
      </ProtectedRoute>
    ),
    errorElement: <Error></Error>,
    id: 'root',
    loader: rootLoader,
    children: [
      {
        index: true,
        element: (
          <Content title={t('statisticPage.header.title')} filterType={FilterType.NORMAL} icon={pulse}>
            <StatisticPage></StatisticPage>
          </Content>
        ),
      },
      {
        path: 'cash-register',
        element: (
          <Content title={t('cashRegister.header.title')} filterType={FilterType.CASH_REGISTER_FILTERS} icon={money}>
            <CashRegisterPage></CashRegisterPage>
          </Content>
        ),
      },
      {
        path: 'health-monitor',
        element: (
          <Content title={t('healthMonitor.header.title.deviceList')} icon={pulse}>
            <HealthMonitor></HealthMonitor>
          </Content>
        ),
        loader: authAndLoadDevicesOnHealthMonitor,
      },
      {
        path: 'health-monitor/:locationName/details/:locationId',
        element: (
          <Content title={'healthMonitor.header.title.deviceDetails'} icon={pulse}>
            <DeviceDetails></DeviceDetails>
          </Content>
        ),
        loader: loadDeviceDetails,
      },
    ],
  },
  {
    path: 'login',
    element: <LoginPage />,
    action: authAction,
    loader: loginLoader,
  },
]);
